<template>
  <div   style="margin-top: 6em">
    <div>
      <h2 class="h1-responsive font-weight-bold  mb-3 text-center">加拿大雇主担保移民</h2>

      <mdb-container>
        <mdb-tabs
          :active="0"
          tabs
          color="red lighten-1"
          card
          class="mb-5"
          :links="[
      { text: 'BC省',slot:'bc-slot' },
      { text: '安省',slot:'an-slot' },
      { text: '大西洋四省',slot:'dxy-slot' }]"
        >

          <template :slot="'bc-slot'">
            <mdb-container>
              <mdb-jumbotron class="text-center hoverable">
                <mdb-row v-animateOnScroll="{animation: 'zoomIn', delay: 0, position: 0}">
                  <mdb-col  md="4" offsetMd="1" class="m-0"  >
                    <mdb-view class="rounded z-depth-2" :src="require('../assets/images/ca/11.jpg')"
                              alt="" style="height: 180px;" >
                      <a>
                        <mdb-mask waves overlay="white-slight"/>
                      </a>
                    </mdb-view>

                  </mdb-col>

                  <mdb-col  md="7" class="text-md-left ml-3 mt-3" >

                    <h4 class="h4 mb-4">BC省雇主担保移民</h4>
                    <p class="font-weight-normal">语言要求低；<br/>
                      没有技术职业限制，不需要职业评估；<br/>
                      审批速度快；<br/>
                    </p>
                    <mdb-btn outline="lightgreen" darkWaves @click.native="showBCModal = true">了解详情</mdb-btn>
                  </mdb-col>
                </mdb-row>
              </mdb-jumbotron>


            </mdb-container>

          </template>

          <template :slot="'an-slot'">
            <mdb-container>
              <mdb-jumbotron class="text-center hoverable">
                <mdb-row  v-animateOnScroll="{animation: 'zoomIn', delay: 0, position: 0}">
                  <mdb-col  md="4" offsetMd="1" class="m-0" >
                    <mdb-view class="rounded z-depth-2" :src="require('../assets/images/ca/12.jpg')"
                              alt=""  style="height: 180px;">
                      <a>
                        <mdb-mask waves overlay="white-slight"/>
                      </a>
                    </mdb-view>

                  </mdb-col>

                  <mdb-col md="7" class="text-md-left ml-3 mt-3">

                    <h4 class="h4 mb-4">安省雇主担保移民</h4>
                    <p class="font-weight-normal">门槛低，无需语言成绩；<br/>
                      一人申请，全家移民；<br/>
                      审理周期短，办理速度快；<br/>
                    </p>
                    <mdb-btn outline="lightgreen" darkWaves @click.native="showANModal = true">了解详情</mdb-btn>
                  </mdb-col>
                </mdb-row>
              </mdb-jumbotron>

            </mdb-container>
          </template>

          <template :slot="'dxy-slot'">
            <mdb-container>
              <mdb-jumbotron class="text-center hoverable">
                <mdb-row  v-animateOnScroll="{animation: 'zoomIn', delay: 0, position: 0}">
                  <mdb-col md="4" offsetMd="1" class="m-0"  >
                    <mdb-view class="rounded z-depth-2" :src="require('../assets/images/ca/9.jpg')"
                              alt=""  style="height: 180px;">
                      <a>
                        <mdb-mask waves overlay="white-slight"/>
                      </a>
                    </mdb-view>

                  </mdb-col>

                  <mdb-col md="7" class="text-md-left ml-3 mt-3">

                    <h4 class="h4 mb-4">大西洋四省雇主担保移民</h4>
                    <p class="font-weight-normal">时间审核快；<br/>
                      门槛低；<br/>
                      一步到位；<br/>
                    </p>
                    <mdb-btn outline="lightgreen" darkWaves @click.native="showDXYModal = true">了解详情</mdb-btn>
                  </mdb-col>
                </mdb-row>
              </mdb-jumbotron>


            </mdb-container>
          </template>

        </mdb-tabs>

      </mdb-container>


      <mdb-modal :show="showBCModal" @close="showBCModal = false" class="text-justify text-monospace" scrollable>
        <mdb-modal-header>
          <mdb-modal-title>加拿大BC省雇主担保移民</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <h5>项目介绍：</h5>
          BC省雇主担保项目是BC省提名项目中的技术移民项目，旨在吸引拥有技术、学历及经验的海外人才。对于有一定语言和学历背景的中产阶层来说，雇主担保无疑是当前移民加拿大的最佳选择。
          <br/>
          <h5>项目优势：</h5>
          1、语言要求低；
          2、没有技术职业限制，不需要职业评估；
          3、审批速度快；
          4、费用低、免面试；
          5、没有资产要求；
          6、一人申请全家移民。
          <br/>
          <h5>申请条件：</h5>
          1. 最近5年必须有至少2年的相关工作经验
          2. 申请人所从事的工作在移民部工作列表NOC中属于0/A/B类
          3. 有一定英语基础，CLB4以上
          <br/>
          <h5>申请流程：</h5>
          1、专业评估与签约
          2、匹配雇主，获得工作Offer
          3、递交省提名申请，获批省提名证书
          4、向联邦移民局递交移民移民签证申请，获得移民签证
          5、全家登陆加拿大

        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn class="mx-auto" outline="secondary" @click.native="showBCModal = false">关闭</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      <mdb-modal :show="showANModal" @close="showANModal = false" class="text-justify text-monospace" scrollable>
        <mdb-modal-header>
          <mdb-modal-title>加拿大安省雇主担保移民</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <h5>项目介绍:</h5>
          加拿大安省雇主担保移民项目是省提名项目下针对雇主担保外籍雇员的一种移民方式。 此项目无硬性学历、语言要求，只要安省雇主担保的职位是加拿大国家职业列表(NOC)中
          0，A，B（管理类，高级技术）类别，且有相关工作经验，即可满足该项目的申请要求。

          <h5>项目优势：</h5>

          　　1. 门槛低，无需语言成绩

          　　2. 一人申请，全家移民

          　　3. 审理周期短，办理速度快

          　　4. 可一步到位拿枫叶卡

          　　5. 安省经济发达，环境优越

          　　6. 省府多伦多为加拿大第一大城市，商机无限

          <h5>申请条件：</h5>

          　　申请资格：

          　　1. 最近5年必须有至少2年的相关工作经验

          　　2. 申请人所从事的工作在移民部工作列表NOC中属于0/A/B类

          　

          　　雇主要求：

          　　1. 如果公司地点是在大多伦多地区，要求在上一财政年度的营业额度不少于100万加元，并已雇有5个全职雇员(为加国公民或永久居民)。

          2. 如果公司地点在大多伦多地区以外，要求在上一财政年度的营业额度不少于50万加元，并已雇有3个全职雇员(为加国公民或永久居民)。

          <h5>申请流程：</h5>
          1、专业评估与签约
          2、匹配雇主，获得工作Offer
          3、递交省提名申请，获批省提名证书
          4、向联邦移民局递交移民移民签证申请，获得移民签证
          5、全家登陆加拿大


        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn class="mx-auto" outline="secondary" @click.native="showANModal = false">关闭</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

      <mdb-modal :show="showDXYModal" @close="showDXYModal = false" class="text-justify text-monospace" scrollable>
        <mdb-modal-header>
          <mdb-modal-title>加拿大西洋四省雇主担保移民</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <h5>项目介绍：</h5>
          2017年3月6日，加拿大移民局推出了《海洋四省移民试点计划
          AIPP》——旨在吸引更多的国际留学生和技术人才在海洋四省（新斯科舍省、新不伦瑞克省、爱德华王子岛省、纽芬兰和拉布拉多省）定居，以解决当地的劳动力短缺问题。海洋四省雇主担保项目自推出以来，因其“成功率高、速度快、门槛低”等优势在加拿大移民项目中一骑绝尘。受担保岗位不断增加，热门行业受加国追捧。

          <h5>项目优势：</h5>
          1、时间审核快
          大西洋移民试点计划从申请到获得移民身份，整个流程大约只要6个月到1年的时间。无需劳工部LMIA审核，使得申请效率大幅提高。

          2、门槛低
          无资产要求；工作资历要求低；语言要求低；低学历要求

          3、一步到位
          一人申请，全家获得枫叶卡。

          <h5>申请条件：</h5>
          1高中以上学历；
          2最近3年内至少1年的工作经验；
          3职业属于NOC中的0、A、B、C类；
          4具备一定的英文能力，最低CLB4（相当于雅思听4.5 说4 读3.5 写4）

          <h5>申请流程：</h5>
          1、专业评估与签约
          2、匹配雇主，雇主向省移民局递交资格审核，并获得雇员批准信(Designation）
          3、雇主向申请人提供符合移民条件的Job Offer
          4、递交省提名申请，获批省提名证书
          5、向联邦移民局递交移民签证申请
          6、获得移民签证，登陆加拿大


        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn class="mx-auto" outline="secondary" @click.native="showDXYModal = false">关闭</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </div>
  </div>




</template>

<script>
  import {mdbScrollSpy,animateOnScroll} from "mdbvue";

  export default {
    name: "CaGuzhu",
    data() {
      return {
        showBCModal: false,
        showANModal: false,
        showDXYModal: false
      }
    },
    directives: {mdbScrollSpy,animateOnScroll}
  }
</script>


